import { render, staticRenderFns } from "./SectorEdit.vue?vue&type=template&id=dce2ccc4&scoped=true"
import script from "./SectorEdit.vue?vue&type=script&lang=js"
export * from "./SectorEdit.vue?vue&type=script&lang=js"
import style0 from "./SectorEdit.vue?vue&type=style&index=0&id=dce2ccc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce2ccc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce2ccc4')) {
      api.createRecord('dce2ccc4', component.options)
    } else {
      api.reload('dce2ccc4', component.options)
    }
    module.hot.accept("./SectorEdit.vue?vue&type=template&id=dce2ccc4&scoped=true", function () {
      api.rerender('dce2ccc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SectorEdit.vue"
export default component.exports